import { MediaFileThumbnailProps } from './Types'
import { VideoThumbnail } from './VideoThumbnail'
import { ImageThumbnail } from './ImageThumbnail'
import { isVideo } from '../utils'

export const MediaFileThumbnail = ({ mediaFile, ...props }: MediaFileThumbnailProps) => {
  const isVideoType = isVideo({ url: mediaFile.url, type: mediaFile.mime_type })

  if (isVideoType) {
    return <VideoThumbnail video={mediaFile} {...props} key={mediaFile.url} />
  }

  return <ImageThumbnail image={mediaFile} {...props} key={mediaFile.url} />
}
